import * as React from 'react'
import { IResultsRisks } from './ResultsRisks'
import Card from '../../Card/Card'
import { ResultStore } from '../../../store/ResultStore'
import { inject } from 'mobx-react'
import { IWeekConsumptionStore } from 'src/store/WeekConsumptionStore'

interface ICarrouselCardProp {
  risk: IResultsRisks
  active: boolean
  WeekConsumptionStore?: IWeekConsumptionStore
}

@inject('WeekConsumptionStore')
export default class CarrouselCard extends React.Component<ICarrouselCardProp> {
  constructor(props: ICarrouselCardProp) {
    super(props)
  }

  public render() {
    let title =
      this.props.WeekConsumptionStore!.getGlassesNumberPerWeek() >= 100 &&
      this.props.risk.percentageRisk
        ? `Au minimum ${this.props.risk.title}`
        : this.props.risk.title
    const subtitle = this.props.risk.subtitle

    if (!!this.props.risk.resultField) {
      title = title.replace('[value]', ResultStore[this.props.risk.resultField])
    }

    return (
      <article className="ResultsRisks-card">
        <Card
          label={this.props.risk.label}
          image={this.props.risk.image}
          variant="risk"
          risk={title}
          subtitle={subtitle}
        />
      </article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsRisks/CarrouselCard.tsx